module.exports = __webpack_public_path__ + "img/maker.ba493d85.png";